import { colors } from 'theme/colors';
import { ScheduleStatus, TaskStatus } from 'utils/api/modules/tasks/tasks.constants';

import { StatusOption } from './StatusPicker';

export const AUDITS_STATUS_OPTIONS: StatusOption[] = [
  {
    value: ScheduleStatus.Overdue,
    label: 'Overdue',
    colors: { background: colors.ui.status.overdue, foreground: colors.common.black },
  },
  {
    value: ScheduleStatus.Upcoming,
    label: 'Upcoming',
    colors: { background: colors.grey[300], foreground: colors.common.black },
  },
  {
    value: TaskStatus.ToDo,
    label: 'To Do',
    colors: { background: colors.tint.primary.medium, foreground: colors.common.black },
  },
  {
    value: TaskStatus.InProgress,
    label: 'In Progress',
    colors: { background: colors.ui.status.inProgress, foreground: colors.common.black },
  },
  {
    value: TaskStatus.Completed,
    label: 'Completed',
    colors: { background: colors.ui.status.completed, foreground: colors.common.black },
  },
  {
    value: ScheduleStatus.WontDo,
    label: "Won't Do",
    colors: { background: colors.grey[600], foreground: colors.common.white },
  },
];

export const STATUS_OPTIONS: StatusOption[] = [
  {
    value: ScheduleStatus.Overdue,
    label: 'Overdue',
    colors: { background: colors.ui.status.overdue, foreground: colors.common.black },
  },
  {
    value: TaskStatus.ToDo,
    label: 'To Do',
    colors: { background: colors.tint.primary.medium, foreground: colors.common.black },
  },
  {
    value: TaskStatus.InProgress,
    label: 'In Progress',
    colors: { background: colors.ui.status.inProgress, foreground: colors.common.black },
  },
  {
    value: ScheduleStatus.Upcoming,
    label: 'Upcoming',
    colors: { background: colors.grey[300], foreground: colors.common.black },
  },
  {
    value: TaskStatus.Completed,
    label: 'Completed',
    colors: { background: colors.ui.status.completed, foreground: colors.common.black },
  },
  {
    value: ScheduleStatus.WontDo,
    label: "Won't Do",
    colors: { background: colors.grey[600], foreground: colors.common.white },
  },
  {
    value: TaskStatus.CantDo,
    label: 'On Hold',
    colors: { background: colors.grey[300], foreground: colors.common.black },
  },
];
